import { Player } from "@lottiefiles/react-lottie-player";
import SoundDesignScoringMob from '../../assets/images/SoundDesignScoring_mob.png';
import SoundDesignScoringWeb from '../../assets/images/SoundDesignScoring_web.png';
import starIconOrange from '../../assets/images/starIcon_orange.png';


const MusicProductionSection = () => {
  const sections = [
    {
      id: 'music-production',
      title: 'MUSIC PRODUCTION',
      mobileImage: 'https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_august_25/zenrik_images/catalog-management-solutions_mob-(1)-17554557280608.webp?v=1755455730',
      desktopImage: 'https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_august_25/zenrik_images/catalog-management-solutions-(2)-17554557451364.webp?v=1755455746',
      imageStyle: 'md:w-full md:h-[60vh] object-cover rounded-xl',
      containerStyle: 'w-full mx-auto',
      features: [
        {
          id: 1,
          title: "Full-Scale Music Production",
          description: "From first note to final master, we build it all from scratch.",
          icon: <img src={starIconOrange} loading="lazy" className="w-5 h-5" />
        },
        {
          id: 2,
          title: "Tailored to Your Style",
          description: "Every beat and lyric crafted to reflect your unique sound.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 3,
          title: "Designed to Stand Out",
          description: "Arranged, recorded, and polished to shine in today's competitive market.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        }
      ]
    },
    {
      id: 'mixing-mastering',
      title: 'MIXING & MASTERING',
      mobileImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1757183164/Scene-4_g8uxgh.json',
      desktopImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1757183017/Scene-3_ordwbn.json',
      imageStyle: 'w-full h-[522px] object-cover rounded-xl transform-gpu',
      imageType: 'lottie',

      mobileImageStyle: 'h-[330px] mx-auto object-cover rounded-xl transform-gpu',
      containerStyle: 'w-full mx-auto',
      features: [
        {
          id: 1,
          title: "Professional Track Balancing",
          description: "Every element sits perfectly in the mix.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 2,
          title: "Enhanced for Every Ear",
          description: "Optimized for clarity, depth, and emotional impact.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 3,
          title: "Ready for Any Platform",
          description: "From streaming to radio to live shows, it hits hard everywhere.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        }
      ]
    },
    {
      id: 'sound-design',
      title: 'SOUND DESIGN & SCORING',
      mobileImage: SoundDesignScoringMob,
      desktopImage: SoundDesignScoringWeb,
      imageStyle: 'w-full h-[522px] object-cover rounded-xl',
      mobileImageStyle: 'h-[330px] mx-auto object-cover rounded-xl',
      containerStyle: 'w-full mx-auto',
      features: [
        {
          id: 1,
          title: "Original Soundscapes ",
          description: "Crafted for films, ads, and games with cinematic precision.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 2,
          title: "Emotion in Every Note",
          description: "Music designed to stir feelings and tell stories.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 3,
          title: "Instant Audience Connection",
          description: "Audio that captivates from the very first second.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        }
      ]
    },
    {
      id: 'composition-arrangement',
      title: 'COMPOSITION & ARRANGEMENT',
      // mobileImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1755725894/slidingCards_t3k1rh.json',
      // desktopImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1755725894/slidingCards_t3k1rh.json',
      mobileImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1757184463/Scene-6_vxwiiy.json',
      desktopImage: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1757183506/Scene-5_cpzuyx.json',
      imageType: 'lottie',
      imageStyle: 'w-full h-[522px] object-cover rounded-xl',
      mobileImageStyle: 'h-[330px] mx-auto object-cover rounded-xl',
      containerStyle: 'w-full mx-auto',
      features: [
        {
          id: 1,
          title: "Memorable Melodies",
          description: "Tunes that linger in the listener's mind.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 2,
          title: "Perfect Instruments",
          description: "Every part chosen to bring the music to life.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        },
        {
          id: 3,
          title: "Maximum Engagement",
          description: "Keeping listeners hooked from start to finish.",
          icon: <img src={starIconOrange} className="w-5 h-5" />
        }
      ]
    }
  ];

  const MusicSection = ({ section }) => {
    return (
      <section id={section.id} className=" flex flex-col bg-black relative overflow-hidden">
        <div className="relative z-10 flex flex-col h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex-shrink-0 pt-[72px] text-center">
            <h2 className="text-[24px] md:text-[36px] font-semibold text-white mb-7 tracking-tight font-inter">
              {section.title}
            </h2>
          </div>

          <div className="flex-1 flex items-center justify-center pb-9">
            <div className={section.containerStyle}>
              <div className="block lg:hidden overflow-hidden rounded-xl">
                {section.imageType === "lottie" ? (
                  <Player
                    autoplay
                    loop
                    src={section.mobileImage}
                    className={section.mobileImageStyle}
                  />
                ) : section.mobileImage.endsWith('.webm') || section.mobileImage.endsWith('.mp4') ? (
                  <video
                    controls={false}
                    className={section.mobileImageStyle + " no-overlay"}
                    src={section.mobileImage}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                  />
                ) : (
                  <img
                    src={section.mobileImage}
                    alt="Music Production Mobile Interface"
                    loading="lazy"
                    className={section.mobileImageStyle}
                  />
                )}
              </div>

              <div className="hidden lg:block overflow-hidden rounded-xl">
                {section.imageType === "lottie" ? (
                  <Player
                    autoplay
                    loop
                    src={section.desktopImage}
                    className={section.imageStyle}
                  />
                ) : (section.desktopImage.endsWith('.webm') || section.desktopImage.endsWith('.mp4')) ? (
                  <video
                    controls={false}
                    className={section.imageStyle + " no-overlay"}
                    src={section.desktopImage}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                  />
                ) : (
                  <img
                    src={section.desktopImage}
                    alt="Music Production Desktop Interface"
                    className={section.imageStyle}
                    loading="lazy"
                  />
                )}
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 pb-8">
            {/* Mobile Layout */}
            <div className="block lg:hidden space-y-4">
              {section.features.map((feature) => (
                <div key={feature.id} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 text-orange-500 mt-0.5">
                    {feature.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-normal text-white mb-2 leading-tight font-inter">
                      {feature.title}
                    </h3>
                    <p className="text-white/50 text-sm md:text-[16px] leading-relaxed font-inter">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Layout */}
            <div className="hidden lg:grid lg:grid-cols-3 lg:gap-7">
              {section.features.map((feature) => (
                <div key={feature.id} className="text-left">
                  <div className="mb-3">
                    <div className="text-orange-500">
                      {feature.icon}
                    </div>
                  </div>
                  <h3 className="text-lg font-normal text-white mb-3 leading-tight font-inter">
                    {feature.title}
                  </h3>
                  <p className="text-white/50 leading-relaxed text-[16px] font-inter">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <>
      {sections.map((section) => (
        <MusicSection key={section.id} section={section} />
      ))}
      <div>
        <video
          controls={false}
          className="w-full md:h-[597px] md:mt-[72px] object-contain md:object-cover pt-[72px] pb-[32px] no-overlay"
          src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757166800/VideoProduction_jjnwpr.mp4'}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        />
      </div>
    </>
  );
};

export default MusicProductionSection;
